import { action } from 'typesafe-actions';
import { AtendimentosMensagensTypes, Messages, Attachments } from './types';

export const sendMenssageRequest = (protocolo: number, texto: string, anexos?: Attachments) =>
  action(AtendimentosMensagensTypes.SEND_MENSSAGE_REQUESTE, {
    protocolo,
    texto,
    anexos,
  });

export const sendMenssageSuccess = (data: Messages) =>
  action(AtendimentosMensagensTypes.SEND_MENSSAGE_SUCCESS, { data });

export const sendMenssageFailure = () =>
  action(AtendimentosMensagensTypes.SEND_MENSSAGE_FAILURE, {});

export const clearMenssage = () => action(AtendimentosMensagensTypes.CLEAR_MENSSAGE);
